import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormViewParams } from '../models/state.model';

export type PageViewStack = Array<FormViewParams>;

const PageViewSlice = createSlice({
  name: 'pageViewStack',
  initialState: [] as PageViewStack,
  reducers: {
    setupViewStack(_, action: PayloadAction<PageViewStack>) {
      sessionStorage.setItem('viewStack', JSON.stringify(action.payload));
      return action.payload;
    },
    setPageViewData(state, action) {
      if (state.length) {
        state[state.length - 1].dataRequest = action.payload;
      }
      sessionStorage.setItem('viewStack', JSON.stringify(state));
      return state;
    },
    openPageView(stack, action: PayloadAction<FormViewParams>) {
      stack.push(action.payload);
      sessionStorage.setItem('viewStack', JSON.stringify(stack));
    },
    closePageView(stack) {
      stack.pop();
      sessionStorage.setItem('viewStack', JSON.stringify(stack));
    },
    clearViewStack() {
      sessionStorage.removeItem('viewStack');
      return [];
    },
  },
});

export const { setupViewStack, openPageView, closePageView, setPageViewData, clearViewStack } =
  PageViewSlice.actions;

const PageViewsReducer = PageViewSlice.reducer;
export default PageViewsReducer;
